require('./bootstrap');
require('startbootstrap-sb-admin-2/js/sb-admin-2');
require('./admin/ajax-form');
require('./admin/scripts');
require('./admin/destroy-confirmation');
require('./admin/clone-confirmation');
require('./admin/confirmation-button');
require('livewire-sortable');
